<template>
  <div class="login-container">
    <!--    <LogoIcon class="logo-icon" />-->
    <span class="title"
      >Activate your artist{{ artists.length > 1 ? "s" : "" }}</span
    >
    <div class="login-content">
      <div v-if="authorization.length" class="card-content">
        <v-braintree
          :card="{
            cvv: {
              required: true,
            },
            overrides: {
              styles: {
                input: {
                  color: 'white',
                },
                ':focus': {
                  color: 'white',
                },
              },
            },
          }"
          :authorization="authorization"
          @load="onLoad"
          @success="onSuccessBillingUpdate"
          @error="onError"
        >
          <template v-slot:button="slotProps">
            <div class="payment-footer">
              <!--              <button @click="back" class="button-text big">-->
              <!--                <span>Back</span>-->
              <!--              </button>-->
              <!-- <div class="total">
                <span class="text">Total</span>
                <span class="value">${{ billingTotal | price }}</span>
              </div> -->
              <button
                @click.prevent="slotProps.submit"
                class="button-default big"
                :disabled="saving || !braintreeInstance"
              >
                <span>Get Started</span>
              </button>
            </div>
          </template>
        </v-braintree>
      </div>
    </div>
  </div>
</template>
<script>
// import LogoIcon from "../../../public/img/icons/logo.svg";
import { M_BRAINTREE_CLIENT_TOKEN, M_BRAINTREE_ADD_ARTISTS } from "@/graphql";
import { mapState } from "vuex";
export default {
  name: "AddArtistWizardStepBilling",
  components: {
    // LogoIcon
  },
  data() {
    return {
      authorization: "",
      braintreeInstance: null,
      saving: false,
    };
  },
  async created() {
    const result = await this.$apollo.mutate({
      client: "localClient",
      mutation: M_BRAINTREE_CLIENT_TOKEN,
    });
    this.authorization = result.data.braintree_client_token.token;
  },
  computed: {
    ...mapState("addArtist", ["coupon", "selected_plan", "artists"]),
    billingTotal() {
      return 0;
    },
  },
  filters: {
    price(val) {
      if (val) {
        return val.toFixed(2);
      } else {
        return 0;
      }
    },
  },
  methods: {
    next() {
      this.$emit("nextStep");
    },
    back() {
      this.$store.commit("signup/previousStep");
    },
    onLoad(instance) {
      this.braintreeInstance = instance;
    },
    onError(error) {
      console.log("onerror", error);
    },
    async onSuccessBillingUpdate(payload) {
      // Do something great with the nonce...
      console.log(payload);

      try {
        this.saving = true;
        let response = await this.$apollo.mutate({
          client: "localClient",
          mutation: M_BRAINTREE_ADD_ARTISTS,
          variables: {
            artists: this.artists.map((x) => ({
              id: x.spotify_id,
              name: x.name,
              image: x.avatar_url,
              selected_plan: this.selected_plan,
            })),
            coupon: this.coupon ?? "",
          },
        });

        console.log(response);
        const { user, token } = response.data.braintree_add_artists;
        if (token) {
          localStorage.setItem("token", token);
          this.$store.commit("addArtist/reset");
          await this.$store.dispatch("setUser", user);
          await this.$store.dispatch("setArtist", user.artists[0]);
          this.$store.commit("signup/setArtists", user.artists);
          this.next();
        } else {
          await this.$store.dispatch("snack", {
            type: "error",
            text: `Oops! Something went wrong. Please try again.`,
          });
        }
      } catch (err) {
        console.log(err);
        await this.$store.dispatch("snack", {
          type: "error",
          text: `Oops! ${err.message.replace("GraphQL error: ", "")}`,
        });
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.login-container {
  width: 100%;
  height: 100%;
  /* BG/type2 */
  //background: $bg-type-2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .logo-icon {
    width: 54px;
  }
  .title {
    display: block;
    margin-top: 30px;
    font-weight: bold;
    font-size: 30px;
    line-height: 42px;
    /* White */
    color: #ffffff;
    mix-blend-mode: normal;
    opacity: 0.9;
  }
  .login-content {
    width: 630px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 12px;
    margin-top: 30px;
    button.continue {
      margin-top: 22px;
      width: 100%;
    }
    .login {
      margin-top: 117px;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      .login-text {
        margin-bottom: 10px;
        /* 16/Regular */
        font-size: 16px;
        line-height: 24px;
        /* Text/type0 */
        color: $text-type-0;
      }
    }
    .card-content {
      width: 100%;
      .payment-footer {
        margin-top: 10px;
        display: flex;
        .button-text {
          width: 120px;
        }
        .total {
          flex: 1;
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          justify-content: center;
          margin-right: 24px;
          .text {
            /* 14/Regular */
            font-size: 14px;
            line-height: 18px;
            text-align: right;
            /* Text/type0 */
            color: $text-type-0;
          }
          .value {
            /* 16/SemiBold */
            font-weight: 600;
            font-size: 16px;
            line-height: 24px;
            text-align: right;
            /* White */
            color: white;
          }
        }
        .button-default {
          width: 155px;
        }
      }
    }
  }
}
</style>
